import { InputText } from "primereact/inputtext";

export const FilterTemplate = ({ filterObjState }) => {
  const [filterObjStateValue, setFilterObjStateValue] = filterObjState;

  return (
    <>
      <div className="p-input-icon-right">
        <i className="pi pi-search" />
        <InputText
          keyfilter={/^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ ]*$/}
          maxLength={50}
          value={filterObjStateValue?.label}
          onChange={(e) =>
            setFilterObjStateValue((prevValue) => ({
              ...prevValue,
              label: e.target.value,
            }))
          }
        />
      </div>
    </>
  );
};
